import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RecurringTaskRunner, RecurringTaskRunnerFactory } from '@nimbus-library/features/recurring-task';
import { ILogger } from '@nimbus-library/features/logger/services/logger/i-logger';
import { IDefaultSearchFilterService } from '@nimbus-library/features/graph/services/i-default-search-filter.service';
import { CacheService, IEntityCacheService } from '@nimbus-library/features/cache/index';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { AcDefaultFilterApiClient } from '@nimbus-portal/features/attendant-console/services/api/ac-default-filter.api-client';

@Injectable()
export class AcDefaultFilterService extends IDefaultSearchFilterService {
  private readonly REFRESH_PERIOD = moment.duration(10, 'seconds');
  private readonly CACHE_TIMEOUT = moment.duration(5, 'seconds');
  private readonly PRELOAD_TIMEOUT = moment.duration(1, 'months');

  private readonly defaultFilterCache: IEntityCacheService<string>;
  private readonly recurringTaskRunner: RecurringTaskRunner<void, string>;

  public constructor(
    private readonly defaultSearchFilterApiClient: AcDefaultFilterApiClient,
    private readonly authenticationService: IAuthenticationService,
    private readonly logger: ILogger,
    cacheService: CacheService,
    recurrentTasksRunnerFactory: RecurringTaskRunnerFactory,
  ) {
    super();
    this.defaultFilterCache = cacheService.for<string>('SwitchboardDefaultFilter', {
      cacheMaxAge: this.CACHE_TIMEOUT,
      preloadMaxAge: this.PRELOAD_TIMEOUT,
    });

    this.recurringTaskRunner = recurrentTasksRunnerFactory.createRunner(() => {
      const user = this.authenticationService.getUserInfo();
      return this.defaultSearchFilterApiClient.getDefaultFilter(user.tenantId).pipe(
        this.defaultFilterCache.useCache(user, false),
        catchError((err) => {
          this.logger.error(err.toString());
          return of('');
        }),
      );
    });
  }

  public getDefaultSearchFilter$(): Observable<string> {
    return this.getDefaultSearchFilterChanges$();
  }

  private getDefaultSearchFilterChanges$(): Observable<string> {
    return this.recurringTaskRunner.start$(undefined, this.REFRESH_PERIOD);
  }
}
